import React from "react";
import classes from "./Layout.module.css";
import {
  Homeoutlined,
  HomeFilled,
  Notificationoutlined,
  NotificationFilled,
  ScheduleOutlined,
  ScheduleFilled,
  ChatOutlined,
  ChatFilled,
  ReviewOutlined,
  ReviewFilled,
  InsightsOutlined,
  InsightsFilled,
  ShortLogo,
  HelpIconBlack,
  SettingsIconBlack,
  logoutIcon,
  AdminDashboardIconOutlined,
  AdminDashboardIconFilled,
  AdminRequestsIconOutlined,
  AdminRequestsIconFilled,
  AdminComplaintsIconFilled,
  AdminComplaintsIconOutlined,
  AdminUsersIconOutlined,
  AdminUsersIconFilled,
  AdminReviewsIconFilled,
} from "../../../constant/imagePath";

import { useHistory, useLocation, Link } from "react-router-dom";
import { SideBarMenu } from "../../../stories/SideBarMenu/SideBarMenu";

const Layout = () => {
  const history = useHistory();
  const location = useLocation();

  const sidebarMenus = [
    {
      icon: AdminDashboardIconOutlined,
      hoverIcon: AdminDashboardIconFilled,
      text: "Dashboard",
      activeText: "dashboard",
      onClick: () => history.push("/admin/dashboard"),
    },
    {
      icon: AdminUsersIconOutlined,
      hoverIcon: AdminUsersIconFilled,
      text: "Users",
      activeText: "users",
      onClick: () => history.push("/admin/users"),
    },
    {
      icon: AdminComplaintsIconOutlined,
      hoverIcon: AdminComplaintsIconFilled,
      text: "Complaints",
      activeText: "complaints",
      onClick: () => history.push("/admin/complaints"),
    },
    {
      icon: AdminRequestsIconOutlined,
      hoverIcon: AdminRequestsIconFilled,
      text: "Requests",
      activeText: "requests",
      onClick: () => history.push("/admin/requests"),
    },
    {
      icon: ReviewOutlined,
      hoverIcon: AdminReviewsIconFilled,
      text: "Reviews",
      activeText: "reviews",
      onClick: () => history.push("/admin/reviews"),
    },
    {
      icon: ChatOutlined,
      hoverIcon: ChatFilled,
      text: "Messages",
      activeText: "messages",

      onClick: () => history.push("/admin/messages"),
    },
  ];

  return (
    <>
      <SideBarMenu
        logo={ShortLogo}
        items={sidebarMenus}
        state={location?.pathname.split("/admin/")[1]}
        customStyle={{ minHeight: "100vh", height: "auto", flexShrink: 0 }}
        menuItems={[
          {
            icon: HelpIconBlack,
            label: "Help",
            onClick: () => history.push("/help"),
          },
          {
            icon: SettingsIconBlack,
            label: "Settings",
            onClick: () => history.push("/admin/settings"),
          },
          { icon: logoutIcon, label: "Log out", onClick: "" },
        ]}
      />
    </>
  );
};

export default Layout;
